import { CircularProgress } from '@mui/material';
import React from 'react';
import './styles.scss'; 

const LoadingIcon = () => {


    return (
        <div className='loading-container'>
            <CircularProgress size='7em' />
        </div>
    );
}

export default LoadingIcon; 